import { type MaybeRef, toValue } from 'vue';

import { getFirewall, getFirewalls, getFirewallStacklets } from './api';
import { firewallKeys } from './keys';

export const firewallQueryOptions = (uuid: MaybeRef<string>) => ({
  queryKey: firewallKeys.firewall(uuid),
  queryFn: () => getFirewall(toValue(uuid)).then((data) => data.firewall),
});

export const firewallsQueryOptions = (params: MaybeRef<{ page: number; query?: string }>) => ({
  queryKey: firewallKeys.firewalls(params),
  queryFn: () => getFirewalls(toValue(params)),
});

export const attachedStackletsQueryOptions = (uuid: MaybeRef<string>) => ({
  queryKey: firewallKeys.attachedStacklets(uuid),
  queryFn: () => getFirewallStacklets(toValue(uuid)),
});
